/* TS hero slideshow — cross-fade between slides, autoplay with pause on
   hover/focus/tab-hidden, dot controls, keyboard and swipe. */
(function () {
  'use strict';

  function Slideshow(root) {
    this.root = root;
    this.slides = Array.prototype.slice.call(
      root.querySelectorAll('[data-ts-hslide-slide]')
    );
    this.dots = Array.prototype.slice.call(
      root.querySelectorAll('[data-ts-hslide-dot]')
    );
    if (this.slides.length < 2) return;

    this.index = 0;
    this.timer = null;
    this.delay = (parseFloat(root.dataset.delay) || 7) * 1000;
    this.autoplay = root.dataset.autoplay === 'true';

    this.bind();
    if (this.autoplay) this.start();
  }

  Slideshow.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        self.go(parseInt(dot.dataset.tsHslideDot, 10));
        self.restart();
      });
    });

    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.restart(); });
    this.root.addEventListener('focusin', function () { self.stop(); });
    this.root.addEventListener('focusout', function () { self.restart(); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) self.stop(); else self.restart();
    });

    // swipe
    var x0 = null;
    this.root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
    }, { passive: true });
    this.root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) { self.go(self.index + (dx < 0 ? 1 : -1)); self.restart(); }
      x0 = null;
    }, { passive: true });
  };

  Slideshow.prototype.go = function (i) {
    var n = this.slides.length;
    this.index = ((i % n) + n) % n;
    var self = this;
    this.slides.forEach(function (s, k) {
      var on = k === self.index;
      s.classList.toggle('is-active', on);
      if (on) s.removeAttribute('aria-hidden');
      else s.setAttribute('aria-hidden', 'true');
    });
    this.dots.forEach(function (d, k) {
      var on = k === self.index;
      d.classList.toggle('is-active', on);
      d.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  };

  Slideshow.prototype.start = function () {
    if (!this.autoplay || this.timer) return;
    var self = this;
    // Reduced motion: keep advancing (CSS drops the drift/stagger) but give
    // readers more time on each slide.
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wait = reduced ? this.delay * 1.6 : this.delay;
    this.timer = setInterval(function () { self.go(self.index + 1); }, wait);
  };

  Slideshow.prototype.stop = function () {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  };

  Slideshow.prototype.restart = function () { this.stop(); this.start(); };

  function init() {
    document.querySelectorAll('[data-ts-hslide]').forEach(function (el) {
      if (!el.__tsHslide) el.__tsHslide = new Slideshow(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
